import React, {useEffect} from 'react';
import {loadTimelineData} from 'anima-timeline';
import "./BlogPage.css";
import NavBar from "../NavBar";
import Footer from "../Footer";
import {BlogCards} from "../../data";
import BlogCardImage from "../../Common/BlogCards"
import Carousel from "../../Desktop/BlogPage/bcarousel"


function App() {
  return (
    <div className="bpt-container-center-horizontal">
      <div className="bpt-x08-blogs-page-tablet screen">
        <div className="bpt-overlap-group">
          <div className="bpt-frame-1603">
            {/* <Frame144 group86Props={frame144Data.group86Props} iconMenuProps={frame144Data.iconMenuProps} /> */}
            <NavBar/>
            <h1 className="bpt-title bpt-valign-text-middle bpt-typographyheadlineh4-extrabold-24">Blogs</h1>
            {/* <Carousel/> */}
            <div className="bpt-overlap-group1">
             
              <div className="bpt-rectangle-78"></div>
              <Carousel/>
              {/* <div className="bpt-frame-1626">
                <div className="bpt-address-1 bpt-valign-text-middle bpt-typographybodytiny-10-regular">05 June 2021</div>
                <div className="bpt-text-1-1 bpt-valign-text-middle bpt-typographyheadlineh4-extrabold-25">
                  Lorem Ipsum passages of Lorem Ipsum available
                </div>
                <p className="bpt-text-2 bpt-typographybodysmall-12-regular">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer quis sapien ac massa dapibus lacinia.
                  Nunc et cursus quam. Cras pharetra condimentum leo,…
                </p>
              </div> */}
            </div>
            <p className="bpt-text-3 bpt-typography-body-smalltext-14-regular">
              There are many variations of passages of Lorem Ipsum available but the majority have suffered dummy
              alteration in that an some form by the injected humour or randomised words which don’t look even that
              slightly believable. If you are Lorem Ipsums your need to be sure there isn’t anything embarrassing. There
              are many variations passages of Lorem as Ipsums available but the majority have suffered that alterations
              in that some form by injected humour or randomised words which don’t looks even slightly that believable.
              If you are Lorem as Ipsum&nbsp;&nbsp;you need to be sure there isn’t anything as embarrassing. There are
              many variation of passages Lorem Ipsum available but the majority have suffered that a aalteration in that
              some form by injected humour or randomised words which don’t look even slightly the believable.
            </p>
            {/* <Footer52 {...footer52Data} /> */}
            {/* <Footer /> */}
          </div>
          <div className="bpt-frame-1643">
            <BlogCardImage />
            {/* {
              BlogCards.map(item =>(
                <div className={item.divtClass}>
                  <div className={item.divtRowClass}>
                  {
                    item.divData.map(itemdata =>(
                      <Frame1598
                        blogThumbnail={itemdata.blogThumbnail}
                        address={itemdata.address}
                        text1={itemdata.text1}
                        text2={itemdata.text2}
                        TclassName={itemdata.TclassName}
                        frame1587Props={itemdata.frame1587Props}
                      />
                    ))
                  }
                  </div>
                </div>
              ))
            } */}

            {/* <Frame1637 
              frame1598Props={frame1637Data.frame1598Props} 
              frame15982Props={frame1637Data.frame15982Props} 
            />
            <Frame1637
              className="bpt-frame-163"
              frame1598Props={frame16372Data.frame1598Props}
              frame15982Props={frame16372Data.frame15982Props}
            />
            <Frame1637
              className="bpt-frame-163"
              frame1598Props={frame16373Data.frame1598Props}
              frame15982Props={frame16373Data.frame15982Props}
            /> */}
            <Button22>VIEW MORE</Button22>
            <Footer/>
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;

function Frame144(props) {
  const { group86Props, iconMenuProps } = props;

  return (
    <div className="bpt-frame-144">
      <Group86 group85={group86Props.group85} whiteProps={group86Props.whiteProps} />
      <IconMenu vector2={iconMenuProps.vector2} vector3={iconMenuProps.vector3} />
    </div>
  );
}


function Group86(props) {
  const { group85, whiteProps } = props;

  return (
    <div className="bpt-group-86">
      <White src={whiteProps.src} />
      <img className="bpt-group-85" src={group85} />
    </div>
  );
}


function White(props) {
  const { src } = props;

  return (
    <div className="bpt-white">
      <img className="bpt-vector" src={src} />
    </div>
  );
}


function IconMenu(props) {
  const { vector2, vector3 } = props;

  return (
    <div className="bpt-icon-menu">
      <img
        className="bpt-vector-2"
        src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-159@2x.svg"
      />
      <img className="bpt-vector-1" src={vector2} />
      <img className="bpt-vector-1" src={vector3} />
    </div>
  );
}


// function Footer52(props) {
//   const {
//     group85,
//     place,
//     overlapGroup,
//     vector2,
//     phone,
//     overlapGroup1,
//     vector3,
//     text15,
//     text14,
//     contactWebuildCom,
//     quickLinks,
//     aboutUs,
//     projects,
//     gallery,
//     knowledgeTransfer,
//     blogs,
//     faqs,
//     group872Props,
//   } = props;

//   return (
//     <div className="bpt-footer">
//       <div className="bpt-flex-row-1">
//         <img
//           className="bpt-vector-3"
//           src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-148@2x.svg"
//         />
//         <img className="bpt-group-85-1" src={group85} />
//         <Group872
//           facebookAppSymbolProps={group872Props.facebookAppSymbolProps}
//           facebookAppSymbolProps2={group872Props.facebookAppSymbolProps2}
//           twitterProps={group872Props.twitterProps}
//         />
//       </div>
//       <div className="bpt-flex-row-2">
//         <div className="bpt-group-32">
//           <div className="bpt-place bpt-valign-text-middle bpt-typographyheadlineh5-extrabold-20">{place}</div>
//           <div className="bpt-flex-row-3">
//             <div className="bpt-flex-col">
//               <div className="bpt-map-pin-1">
//                 <div className="bpt-overlap-group2" style={{ backgroundImage: `url(${overlapGroup})` }}>
//                   <img className="bpt-vector-4" src={vector2} />
//                 </div>
//               </div>
//               <div className="bpt-phone" style={{ backgroundImage: `url(${phone})` }}></div>
//               <div className="bpt-mail">
//                 <div className="bpt-overlap-group3" style={{ backgroundImage: `url(${overlapGroup1})` }}>
//                   <img className="bpt-vector-5" src={vector3} />
//                 </div>
//               </div>
//             </div>
//             <div className="bpt-flex-col-1">
//               <p className="bpt-text-5 bpt-typography-body-smalltext-14-regular">{text15}</p>
//               <div className="bpt-flex-col-item bpt-valign-text-middle bpt-typography-body-smalltext-14-regular">{text14}</div>
//               <div className="bpt-flex-col-item bpt-valign-text-middle bpt-typography-body-smalltext-14-regular">
//                 {contactWebuildCom}
//               </div>
//             </div>
//           </div>
//         </div>
//         <div className="bpt-group-147">
//           <div className="bpt-quick-links bpt-valign-text-middle bpt-typographyheadlineh5-extrabold-20">{quickLinks}</div>
//           <div className="bpt-flex-row-4">
//             <div className="bpt-about-us bpt-valign-text-middle bpt-typographybody16-regular">{aboutUs}</div>
//             <div className="bpt-projects bpt-valign-text-middle bpt-typographybody16-regular">{projects}</div>
//           </div>
//           <div className="bpt-flex-row">
//             <div className="bpt-gallery bpt-valign-text-middle bpt-typographybody16-regular">{gallery}</div>
//             <div className="bpt-knowledge-transfer bpt-valign-text-middle bpt-typographybody16-regular">{knowledgeTransfer}</div>
//           </div>
//           <div className="bpt-flex-row">
//             <div className="bpt-blogs bpt-valign-text-middle bpt-typographybody16-regular">{blogs}</div>
//             <div className="bpt-fa-qs bpt-valign-text-middle bpt-typographybody16-regular">{faqs}</div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }


function Group872(props) {
  const { facebookAppSymbolProps, facebookAppSymbolProps2, twitterProps } = props;

  return (
    <div className="bpt-group-87">
      <FacebookAppSymbol src={facebookAppSymbolProps.src} />
      <Instagram2 overlapGroup1={facebookAppSymbolProps2.overlapGroup1} vector2={facebookAppSymbolProps2.vector2} />
      <Twitter src={twitterProps.src} />
    </div>
  );
}


function FacebookAppSymbol(props) {
  const { src } = props;

  return (
    <div className="bpt-facebook-app-symbol">
      <img className="bpt-f-1" src={src} />
    </div>
  );
}


function Instagram2(props) {
  const { overlapGroup1, vector2 } = props;

  return (
    <div className="bpt-instagram">
      <div className="bpt-overlap-group2-1" style={{ backgroundImage: `url(${overlapGroup1})` }}>
        <img
          className="bpt-vector-6"
          src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-18@2x.svg"
        />
        <img className="bpt-vector-7" src={vector2} />
      </div>
    </div>
  );
}


function Twitter(props) {
  const { src } = props;

  return (
    <div className="bpt-twitter">
      <img className="bpt-vector-8" src={src} />
    </div>
  );
}


function Frame1637(props) {
  const { className, frame1598Props, frame15982Props } = props;

  return (
    <div className={`bpt-frame-1637 ${className || ""}`}>
      {/* <Frame1598
        blogThumbnail={frame1598Props.blogThumbnail}
        address={frame1598Props.address}
        text6={frame1598Props.text6}
        text7={frame1598Props.text7}
        readMore={frame1598Props.readMore}
        className={frame1598Props.className}
        plusProps={frame1598Props.plusProps}
      />
      <Frame1598
        blogThumbnail={frame15982Props.blogThumbnail}
        address={frame15982Props.address}
        text6={frame15982Props.text6}
        text7={frame15982Props.text7}
        readMore={frame15982Props.readMore}
        className={frame15982Props.className}
        plusProps={frame15982Props.plusProps}
      /> */}
    </div>
  );
}


function Frame1598(props) {
  const { blogThumbnail, address, text1, text2,  TclassName, frame1587Props } = props;

  return (
    <div className={`bpt-frame-1598 ${TclassName || ""}`}>
      <div className="bpt-blog-thumbnail" style={{ backgroundImage: `url(${blogThumbnail})` }}></div>
      <div className="bpt-address bpt-valign-text-middle bpt-overpass-semi-bold-scarpa-flow-16px">{address}</div>
      <div className="bpt-text bpt-valign-text-middle bpt-typographyheadlineh5-extrabold-20">{text1}</div>
      <p className="bpt-text-1 bpt-typography-body-smalltext-14-regular">{text2}</p>
      <Frame1587 text3={frame1587Props.text3} plusProps={frame1587Props.plusProps} />
    </div>
  );
}

function Frame1587(props) {
  const { text3, plusProps } = props;

  return (
    <div className="bpt-frame-1587">
      <div className="bpt-text-2 bpt-valign-text-middle bpt-typographybodycaption-14-semi-bold">{text3}</div>
      <Plus src={plusProps.src} />
    </div>
  );
}

function Plus(props) {
  const { src } = props;

  return (
    <div className="bpt-arrowsarrow-right">
      <img className="bpt-vector-9" src={src} />
    </div>
  );
}


function Button22(props) {
  const { children } = props;

  useEffect(() => {
    loadTimelineData(x27326493TimelineData);
  }, []);

  return (
    <div className="bpt-x27326493 bpt-component bpt-component-wrapper not-ready">
      <div className="bpt-master-button-6i0U1X">
        <div className="bpt-button-i2732649351-QdN0U2 bpt-valign-text-middle">{children}</div>
      </div>
    </div>
  );
}

const x27326493TimelineData = [
  {
    initial_state_name: "Property-1=Tertiary",
    root_element: ".bpt-x27326493",
    states_flow: {
      "Property-1=Primary": {
        listeners: [],
        overrides: {},
      },
      "Property-1=Secondary": {
        listeners: [],
        overrides: {},
      },
      "Property-1=Tertiary": {
        listeners: [],
        overrides: {},
      },
    },
  },
];

const whiteData = {
    src: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-98@2x.svg",
};

const group86Data = {
    group85: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/group-85-7@2x.svg",
    whiteProps: whiteData,
};

const iconMenuData = {
    vector2: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-159@2x.svg",
    vector3: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-159@2x.svg",
};

const frame144Data = {
    group86Props: group86Data,
    iconMenuProps: iconMenuData,
};

const facebookAppSymbolData = {
    src: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/f-1-11@2x.svg",
};

const instagram2Data = {
    overlapGroup1: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-215@2x.svg",
    vector2: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-19@2x.svg",
};

const twitterData = {
    src: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-218@2x.svg",
};

const group872Data = {
    facebookAppSymbolProps: facebookAppSymbolData,
    facebookAppSymbolProps2: instagram2Data,
    twitterProps: twitterData,
};

// const footer52Data = {
//     group85: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/group-85-29@2x.svg",
//     place: "Contact",
//     overlapGroup: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-20@2x.svg",
//     vector2: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-150@2x.svg",
//     phone: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-212@2x.svg",
//     overlapGroup1: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-277@2x.svg",
//     vector3: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-278@2x.svg",
//     text15: "Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint.",
//     text14: "+91 8976535221, +91 8755645342",
//     contactWebuildCom: "contact@webuild.com",
//     quickLinks: "Quick Links",
//     aboutUs: "About Us",
//     projects: "Projects",
//     gallery: "Gallery",
//     knowledgeTransfer: "Knowledge Transfer",
//     blogs: "Blogs",
//     faqs: "FAQ’s",
//     group872Props: group872Data,
// };

const plusData = {
    src: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-174@2x.svg",
};

const frame1598Data = {
    blogThumbnail: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/rectangle-83-42@2x.png",
    address: "5 June 2021",
    text6: "Lorem Ipsum passages of Lorem Ipsum available",
    text7: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer quis sapien ac massa dapibus lacinia. Nunc et cursus quam. Cras pharetra condimentum leo,…",
    readMore: "Read More",
    className: "",
    plusProps: plusData,
};

const plus2Data = {
    src: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-174@2x.svg",
};

const frame15982Data = {
    blogThumbnail: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/rectangle-83-43@2x.png",
    address: "5 June 2021",
    text6: "Lorem Ipsum passages of Lorem Ipsum available",
    text7: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer quis sapien ac massa dapibus lacinia. Nunc et cursus quam. Cras pharetra condimentum leo,…",
    readMore: "Read More",
    className: "bpt-frame-1598-1",
    plusProps: plus2Data,
};

const frame1637Data = {
    frame1598Props: frame1598Data,
    frame15982Props: frame15982Data,
};

const plus3Data = {
    src: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-174@2x.svg",
};

const frame15983Data = {
    blogThumbnail: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/rectangle-83-44@2x.png",
    address: "5 June 2021",
    text6: "Lorem Ipsum passages of Lorem Ipsum available",
    text7: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer quis sapien ac massa dapibus lacinia. Nunc et cursus quam. Cras pharetra condimentum leo,…",
    readMore: "Read More",
    className: "bpt-frame-1598",
    plusProps: plus3Data,
};

const plus4Data = {
    src: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-174@2x.svg",
};

const frame15984Data = {
    blogThumbnail: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/rectangle-83-45@2x.png",
    address: "5 June 2021",
    text6: "Lorem Ipsum passages of Lorem Ipsum available",
    text7: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer quis sapien ac massa dapibus lacinia. Nunc et cursus quam. Cras pharetra condimentum leo,…",
    readMore: "Read More",
    className: "bpt-frame-1598-1",
    plusProps: plus4Data,
};

const frame16372Data = {
    frame1598Props: frame15983Data,
    frame15982Props: frame15984Data,
};

const plus5Data = {
    src: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-174@2x.svg",
};

const frame15985Data = {
    blogThumbnail: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/rectangle-83-46@2x.png",
    address: "5 June 2021",
    text6: "Lorem Ipsum passages of Lorem Ipsum available",
    text7: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer quis sapien ac massa dapibus lacinia. Nunc et cursus quam. Cras pharetra condimentum leo,…",
    readMore: "Read More",
    className: "bpt-frame-1598",
    plusProps: plus5Data,
};

const plus6Data = {
    src: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-174@2x.svg",
};

const frame15986Data = {
    blogThumbnail: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/rectangle-83-47@2x.png",
    address: "5 June 2021",
    text6: "Lorem Ipsum passages of Lorem Ipsum available",
    text7: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer quis sapien ac massa dapibus lacinia. Nunc et cursus quam. Cras pharetra condimentum leo,…",
    readMore: "Read More",
    className: "bpt-frame-1598-1",
    plusProps: plus6Data,
};

const frame16373Data = {
    frame1598Props: frame15985Data,
    frame15982Props: frame15986Data,
};

